import React from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useLang } from "../context/LanguageContext";
import provincesGeo from "../data/provinces_geo.json";

const provinceStyle = {
  fillColor: "#17402A",
  fillOpacity: 0.5,
  color: "#92BA43",
  weight: 2,
  opacity: 0.9,
};

// Bounds covering Thrace (NW) + İzmir (Aegean) clusters
const BOUNDS = [
  [42.1, 25.8],
  [37.9, 28.0],
];

const listingIcon = L.divIcon({
  className: "sf-pin",
  html: '<span class="sf-pin-inner"></span>',
  iconSize: [30, 42],
  iconAnchor: [15, 40],
  popupAnchor: [0, -38],
});

export const TurkeyMap = ({ regions = [], projects = [] }) => {
  const { t, tc } = useLang();
  const listings = projects.filter((p) => p.lat != null && p.lng != null);

  return (
    <div className="relative w-full rounded-2xl overflow-hidden border border-green/15" data-testid="turkey-map" style={{ zIndex: 0 }}>
      <MapContainer
        bounds={BOUNDS}
        scrollWheelZoom={false}
        style={{ height: "540px", width: "100%", background: "#EAF1E4" }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>'
        />

        {/* Highlighted target provinces */}
        <GeoJSON data={provincesGeo} style={() => provinceStyle} />

        {/* Listing (project) pins */}
        {listings.map((p) => (
          <Marker key={p.slug} position={[p.lat, p.lng]} icon={listingIcon} data-testid={`map-listing-${p.slug}`}>
            <Popup className="sf-popup" minWidth={230} maxWidth={250}>
              <Link to={`/projects/${p.slug}`} className="sf-popup-card" data-testid={`popup-project-${p.slug}`}>
                <img src={p.image} alt={tc(p.title)} className="sf-popup-img" />
                <div className="sf-popup-body">
                  <div className="sf-popup-loc">{p.location}</div>
                  <div className="sf-popup-title">{tc(p.title)}</div>
                  {p.price && <div className="sf-popup-price">{p.price}</div>}
                  <span className="sf-popup-cta">{t.cta.viewProject} →</span>
                </div>
              </Link>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      {/* Legend */}
      <div className="absolute bottom-3 start-3 z-[500] glass-dark rounded-lg px-3 py-2 flex items-center gap-3 text-white text-[11px]" data-testid="map-legend">
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm" style={{ background: "#17402A", border: "1px solid #92BA43" }} /> {t.regions.overline}</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-gold" /> {t.projects.overline} ({listings.length})</span>
      </div>
    </div>
  );
};
